export function initAjaxFilter() {
    const ajaxButtons= document.querySelectorAll('.js-ajax-filter');
    if(ajaxButtons.length > 0) {
       /* ajaxButtons.forEach(button => {
            button.addEventListener('click', function(event) {
                event.preventDefault();
                const dataType = event.target.dataset.type;
                ajaxButtons.forEach(btn => btn.classList.remove('active'));

                event.target.classList.add('active');
                activeMenuPoint=dataType;
                page=1;
                updateStammtischEntriesVisibility();
            });
        });*/
    }
}
function updateStammtischEntriesVisibility(){
    const entries = document.querySelectorAll('.js-timeline-entry');
    for (const entry of entries) {
       if(!entry.classList.contains("hidden")){
           console.log(entry.dataset.type,activeMenuPoint)
           if(entry.dataset.type === activeMenuPoint || activeMenuPoint === "all"){
               entry.dataset.hiddenByFilter="false";

           }else{
               entry.dataset.hiddenByFilter="true";
           }
       }
        // Do something
    }
}